import "./index.css"

import {Controller as BaseController} from "stimulus"

export class Controller extends BaseController {
}
